import script from "./DashboardWidgetWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardWidgetWrapper.vue?vue&type=script&setup=true&lang=js"

import "./DashboardWidgetWrapper.vue?vue&type=style&index=0&id=668f50c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-668f50c2"]])

export default __exports__